import { atom } from "recoil";

export const createAuthBannerSettingsForm = () => ({
	show: false,
	loaded: false,
	saving: false,
	image: "",
	title: "",
	titleType: "local",
	description: "",
	descriptionType: "local",
});

export const authBannerSettingsModalStore = atom({
	key: "authBannerSettingsModalStore",
	default: createAuthBannerSettingsForm(),
});
